import tw, { styled, css } from 'twin.macro';
import { StyledRichText } from '@/components/RichTextBlock/RichTextBlock.styles';
import Icon from '@/components/Icon/IconAsset';
import Link from '@/components/Link/Link';
import { StyledContainer as StarRatingContainer } from '@/components/StarRating/StarRating.styles';
import InfoTag from '@/components/InfoTag/InfoTag';

export const StyledArticle = styled.article`
  ${StarRatingContainer} {
    ${tw`mb-2`}
  }
`;

export const StyledIcon = styled(Icon)`
  ${tw`w-64 h-8`}
  ${tw`text-[transparent]`}
  ${tw`mb-2`}
`;

export const StyledEyebrow = styled.span`
  ${tw`block`}
  ${tw`mb-2`}
  ${tw`font-inter font-semi-bold`}
  ${tw`text-primary-p1 text-tag-m uppercase`}
`;

export const StyledHeadline = styled.h2`
  ${tw`block`}
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-mobile-heading-l md:text-heading-m text-secondary-s1`}
`;

export const StyledDescription = styled.div`
  ${tw`block`}
  ${tw`font-inter font-regular`}
  ${tw`text-body-l text-primary-p1`}
  ${tw`pt-2`}

  section {
    ${tw`pb-0`}
  }
`;

export const StyledButton = styled(Link)`
  ${tw`text-left`}
  ${tw`pt-1`}
`;

export const StyledImageContainer = styled.div`
  ${tw`pb-2`}
`;

export const StyledContent = styled.div<{ isCampaignForm: boolean }>`
  ${tw`relative`}
  ${tw`mb-2`}

  ${StyledDescription} ${StyledRichText} {
    p {
      ${tw`mt-2`}
    }
  }

  ${({ isCampaignForm }) =>
    isCampaignForm &&
    css`
      ${StyledDescription} ${StyledRichText} {
        ul {
          ${tw`list-outside`}
        }
        li {
          ${tw`bg-[url("/svg/check-circle.svg")] bg-no-repeat bg-left-top`}
          ${tw`pl-[36px]`}
          ${tw`mb-[6px]`}
          ${tw`list-outside list-none`}
        }
      }
    `}
`;

export const StyledInfoTag = styled(InfoTag)`
  ${tw`mb-2`}
`;
